import { defineMessages } from 'react-intl';

// ─── Messages ────────────────────────────────────────────────────────────────

export const navbarV2Messages = defineMessages({
  account: {
    defaultMessage: 'Account',
    description: 'Navbar V2 | Account link label',
  },
  bag: {
    defaultMessage: 'Bag',
    description: 'Navbar V2 | Bag button label',
  },
  bagAccessibilityLabel: {
    defaultMessage: '{count, plural, =0 {Bag} one {Bag, # item} other {Bag, # items}}',
    description: 'Navbar V2 | Bag button accessibility label',
  },
  buyGiftCards: {
    defaultMessage: 'Buy Gift Cards',
    description: 'Navbar V2 | More menu | Fallback gift cards link label',
  },
  closeNavigation: {
    defaultMessage: 'Close navigation',
    description: 'Navbar V2 | Close navigation button accessibility label',
  },
  closeNavigationBackdrop: {
    defaultMessage: 'Close navigation backdrop',
    description: 'Navbar V2 | Navigation backdrop accessibility label',
  },
  findLocationNearYou: {
    defaultMessage: 'Find location near you',
    description: 'Navbar V2 | Find location button label',
  },
  goBack: {
    defaultMessage: 'Go back',
    description: 'Navbar V2 | Back link accessibility label',
  },
  groupOrderInviteeTitle: {
    defaultMessage: "{host_name}'s Group Order",
    description: 'Navbar V2 | Invitee group order title',
  },
  groupOrderLocationEyebrow: {
    defaultMessage:
      'Group Order - {orderChannel, select, delivery {Deliver to:} pickup {Pickup from:} outpost {Outpost at:} other {}}',
    description: 'Navbar V2 | Host group order location eyebrow',
  },
  giftCardsDescription: {
    defaultMessage: 'Give the gift of green',
    description: 'Navbar V2 | More menu | Fallback gift cards link description',
  },
  giftCardsImageAlt: {
    defaultMessage: 'Sweetgreen gift cards',
    description: 'Navbar V2 | More menu | Fallback gift cards image accessibility label',
  },
  home: {
    defaultMessage: 'Home',
    description: 'Navbar V2 | Home link label',
  },
  homeAccessibilityLabel: {
    defaultMessage: 'Sweetgreen home',
    description: 'Navbar V2 | Home link accessibility label',
  },
  logInOrSignUp: {
    defaultMessage: 'Log in / Sign up',
    description: 'Navbar V2 | Authentication button label',
  },
  locationEyebrow: {
    defaultMessage:
      '{orderChannel, select, delivery {Deliver to} pickup {Pickup from} outpost {Outpost at} other {Deliver to}}',
    description: 'Navbar V2 | Location button eyebrow',
  },
  menu: {
    defaultMessage: 'Menu',
    description: 'Navbar V2 | Menu link label',
  },
  more: {
    defaultMessage: 'More',
    description: 'Navbar V2 | More link label',
  },
  moreMenu: {
    defaultMessage: 'More menu',
    description: 'Navbar V2 | More menu accessibility label',
  },
  myAccount: {
    defaultMessage: 'My account',
    description: 'Navbar V2 | More menu | Account link label',
  },
  navigationMenu: {
    defaultMessage: 'Navigation menu',
    description: 'Navbar V2 | Drawer accessibility label',
  },
  openNavigation: {
    defaultMessage: 'Open navigation',
    description: 'Navbar V2 | Open navigation button accessibility label',
  },
  rewards: {
    defaultMessage: 'Rewards',
    description: 'Navbar V2 | Rewards link label',
  },
  signInCreateAccount: {
    defaultMessage: 'Sign in / Create account',
    description: 'Navbar V2 | Drawer | Authentication link label',
  },
  startOrder: {
    defaultMessage: 'Order',
    description: 'Navbar V2 | Start order button label',
  },
  viewOrderHistory: {
    defaultMessage: 'View order history',
    description: 'Navbar V2 | More menu | Order history link label',
  },
});
